const baseURL = process.env.REACT_APP_BASE_URL + 'manufacturing/';

async function loadJson(data, url) {
  try {
    const response = await fetch(baseURL + url + '.php', {
      method: 'POST',
      body: data,
    });
    const resp = await response.text();
    if (resp !== 'INVALID') {
      try {
        return JSON.parse(resp);
      } catch (err) {
        return resp;
      }
    }
    return 'INVALID';
  } catch (error) {
    console.error('Error:' + error);
    return null;
  }
}

export async function list_manufacturing_orders(token) {
  const data = new FormData();
  data.append('token', token);
  return loadJson(data, 'get/list_orders');
}

export async function list_available_opportunities(token) {
  const data = new FormData();
  data.append('token', token);
  return loadJson(data, 'get/list_available_opportunities');
}

export async function get_manufacturing_order(token, manufacturing_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  return loadJson(data, 'get/get_order');
}

export async function get_manufacturing_order_by_opportunity(token, opportunity_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('opportunity_id', String(opportunity_id));
  return loadJson(data, 'get/get_order_by_opportunity');
}

export async function create_manufacturing_order(token, payload = {}) {
  const data = new FormData();
  data.append('token', token);
  const opportunityId = payload?.opportunity_id;
  const title = payload?.title;
  if (opportunityId != null && Number(opportunityId) > 0) {
    data.append('opportunity_id', String(opportunityId));
  }
  if (title != null && String(title).trim() !== '') {
    data.append('title', String(title).trim());
  }
  return loadJson(data, 'set/create_order');
}

export async function update_manufacturing_order(token, manufacturing_id, fields) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  Object.entries(fields || {}).forEach(([key, value]) => {
    data.append(key, value == null ? '' : String(value));
  });
  return loadJson(data, 'set/update_order');
}

export async function change_manufacturing_status(token, manufacturing_id, status, extra = {}) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  data.append('status', String(status));
  if (extra.factura != null) data.append('factura', String(extra.factura));
  if (extra.guia != null) data.append('guia', String(extra.guia));
  if (extra.fecha_warranty != null) data.append('fecha_warranty', String(extra.fecha_warranty));
  return loadJson(data, 'set/change_status');
}

export async function add_manufacturing_comment(token, manufacturing_id, comments) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  data.append('comments', comments != null ? String(comments) : '');
  return loadJson(data, 'set/add_comment');
}

export async function upload_manufacturing_file(token, manufacturing_id, file) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  data.append('file', file);
  return loadJson(data, 'set/upload_file');
}

export async function delete_manufacturing_file(token, file_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('file_id', String(file_id));
  return loadJson(data, 'set/delete_file');
}

export async function list_manufacturing_catalog_products(token) {
  const data = new FormData();
  data.append('token', token);
  return loadJson(data, 'get/list_products');
}

export async function add_manufacturing_product(token, manufacturing_id, product_id, units) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  data.append('product_id', String(product_id));
  data.append('units', String(units));
  return loadJson(data, 'set/add_product');
}

export async function update_manufacturing_product(token, manufacturing_product_id, fields = {}) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_product_id', String(manufacturing_product_id));
  Object.entries(fields || {}).forEach(([key, value]) => {
    data.append(key, value == null ? '' : String(value));
  });
  return loadJson(data, 'set/update_product');
}

export async function delete_manufacturing_product(token, manufacturing_product_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_product_id', String(manufacturing_product_id));
  return loadJson(data, 'set/delete_product');
}

/**
 * @param {string} token
 * @param {number|string} manufacturing_id
 * @param {{ opportunity_product_id?: number|string, manufacturing_product_id?: number|string }} lineRef
 * @param {string} serial
 */
export async function add_manufacturing_serial(token, manufacturing_id, lineRef, serial) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  const oppLine = lineRef?.opportunity_product_id;
  const mfgLine = lineRef?.manufacturing_product_id;
  if (oppLine != null && Number(oppLine) > 0) {
    data.append('opportunity_product_id', String(oppLine));
  }
  if (mfgLine != null && Number(mfgLine) > 0) {
    data.append('manufacturing_product_id', String(mfgLine));
  }
  data.append('serial', serial != null ? String(serial) : '');
  return loadJson(data, 'set/add_serial');
}

/**
 * @param {string} token
 * @param {number|string} manufacturing_id
 * @param {{ opportunity_product_id?: number|string, manufacturing_product_id?: number|string }} lineRef
 * @param {string[]} serials
 */
export async function add_manufacturing_serials_bulk(token, manufacturing_id, lineRef, serials) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  const oppLine = lineRef?.opportunity_product_id;
  const mfgLine = lineRef?.manufacturing_product_id;
  if (oppLine != null && Number(oppLine) > 0) {
    data.append('opportunity_product_id', String(oppLine));
  }
  if (mfgLine != null && Number(mfgLine) > 0) {
    data.append('manufacturing_product_id', String(mfgLine));
  }
  data.append('serials', JSON.stringify(Array.isArray(serials) ? serials : []));
  return loadJson(data, 'set/add_serials_bulk');
}

/**
 * Parsea archivo plano: un serial por línea (.txt / .csv simple).
 * Omite líneas vacías y un posible encabezado "serial"/"pin"/"serie".
 */
export function parseManufacturingSerialFile(text, existingSerials = []) {
  const raw = String(text || '').replace(/^\uFEFF/, '');
  const lines = raw.split(/\r\n|\n|\r/);
  const existingSet = new Set(
    (existingSerials || [])
      .map((s) => String(s || '').trim().toUpperCase())
      .filter(Boolean)
  );

  const errors = [];
  const warnings = [];
  const valid = [];
  const seen = new Set();
  const SERIAL_RE = /^[A-Za-z0-9\-_\/.#]+$/;
  const HEADER_RE = /^(serial|seriales|serie|pin|pines|sn|s\/n)$/i;

  lines.forEach((line, index) => {
    const lineNo = index + 1;
    let value = String(line || '').trim();
    if (!value) return;

    // CSV de una columna: tomar primera celda
    if (value.includes(',') || value.includes(';') || value.includes('\t')) {
      const parts = value.split(/[,;\t]/);
      value = String(parts[0] || '').trim().replace(/^["']|["']$/g, '');
    }

    if (!value) return;
    if (lineNo === 1 && HEADER_RE.test(value)) {
      warnings.push({ line: lineNo, serial: value, message: 'Encabezado detectado y omitido.' });
      return;
    }
    if (value.length > 100) {
      errors.push({ line: lineNo, serial: value.slice(0, 40) + '…', message: 'Supera 100 caracteres.' });
      return;
    }
    if (!SERIAL_RE.test(value)) {
      errors.push({
        line: lineNo,
        serial: value,
        message: 'Formato inválido (solo letras, números y - _ / . #).',
      });
      return;
    }

    const key = value.toUpperCase();
    if (seen.has(key)) {
      errors.push({ line: lineNo, serial: value, message: 'Duplicado dentro del archivo.' });
      return;
    }
    seen.add(key);

    if (existingSet.has(key)) {
      warnings.push({ line: lineNo, serial: value, message: 'Ya está asignado a este producto.' });
      return;
    }

    valid.push(value);
  });

  return {
    ok: errors.length === 0 && valid.length > 0,
    valid,
    errors,
    warnings,
    totalLines: lines.filter((l) => String(l || '').trim()).length,
  };
}

export async function delete_manufacturing_serial(token, serial_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('serial_id', String(serial_id));
  return loadJson(data, 'set/delete_serial');
}

export async function upload_manufacturing_content_image(token, manufacturing_id, file) {
  const data = new FormData();
  data.append('token', token);
  data.append('manufacturing_id', String(manufacturing_id));
  data.append('file', file);
  return loadJson(data, 'set/upload_content_image');
}

export const MANUFACTURING_STATUS_LABELS = {
  0: 'Pendiente',
  1: 'Producción',
  2: 'Empaque',
  3: 'Despachado',
  4: 'Facturado',
  5: 'Anulado',
};

export const MANUFACTURING_PRIORITY_LABELS = {
  1: 'Urgente',
  2: 'Normal',
  3: 'Baja',
};

export function manufacturingFileUrl(manufacturing_id, filename) {
  return `https://team.tomi.la/storage/manufacturing/${manufacturing_id}/${filename}`;
}
